export default "__VITE_ASSET__cdf3fc62__"